import React, { useCallback, useRef, useState } from "react";
import type { MenuProps } from "antd";
import { isOwnProperty } from "@/utils/common";
interface LevelKeysProps {
  key?: string;
  children?: LevelKeysProps[];
}


interface MenuConfigProps {
  initConfig:any;
  menuSelectHandle: (value: any) => void;
}
/**
 * 查找子节点 并返回 链路
 * @param list 
 * @param id 
 * @returns 
 */
 export function findParentIdsOptimized(data: any, targetId: any) {
    const result: any[] = [];
    
    function traverse(nodes: any, targetId: any) {
        for (const node of nodes) {
            // 将当前节点ID加入路径
            result.push(node.id);
            
            // 如果找到目标节点
            if (node.id === targetId) {
                return true;
            }
            
            // 如果有子节点，递归查找
            if (node.children && node.children.length > 0) {
                const found = traverse(node.children, targetId);
                if (found) return true;
            }
            
            // 如果未找到，移除当前节点
            result.pop();
        }
        return false;
    }
    
    traverse(data, targetId);
    // 移除目标节点自身（最后一个元素）
    return result.slice(0, -1);
}

 /**
 * 递归查找一级分类
 * @param list 分类列表
 * @returns 返回一级分类列表
 */
export const findFirstLevelCategory = (list: any[]) => {
  const firstChildList: any[] = []; //
  if (list?.length > 0) {
    const firstChild = list[0]; // 获取列表中的第一个元素
    // 检查当前分类是否存在子分类且子分类数量大于0
    if (isOwnProperty(firstChild,"children")) {
      // 将当前分类加入结果数组
      firstChildList.push(firstChild);
      // 递归处理子分类
      firstChildList.push(...findFirstLevelCategory(firstChild.children));
    } else {
      // 如果没有子分类，直接将当前分类加入结果数组
      firstChildList.push(firstChild);
    }
  }
  return firstChildList; // 返回一级分类列表
};

/**
 * 获取默认展开和默认选中项
 * @param list 
 * @returns 
 */
export const findFirstLevelCategoryKeys = (list: any[]) => {
  //检索出第一级分类
    const firstList = findFirstLevelCategory(list);
    //默认展开第一项的key
    const defaultOpenKeys = firstList.filter((item, index) => isOwnProperty(item,"children")).map((item) => item.id);
    //默认选中项的key
    const defaultSelectedKeys = firstList[firstList.length - 1];

    return {
      openKeys:defaultOpenKeys,
      selectedKeys: isOwnProperty(defaultSelectedKeys,"children") ? [defaultOpenKeys[defaultOpenKeys.length - 1]] : [defaultSelectedKeys?.id],
    }
}

export const getLevelKeys = (items1: LevelKeysProps[]) => {
  const key: Record<string, number> = {};
  const func = (items2: LevelKeysProps[], level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level;
      }
      if (item.children) {
        func(item.children, level + 1);
      }
    });
  };
  func(items1);
  return key;
};

const useMenusSelect = (props:MenuConfigProps): [React.MutableRefObject<any>, (callback: (value: any) => any) => void] => {
  const [menusSelectConfig, setMenusSelectConfig] = useState<MenuProps>({
    defaultOpenKeys: [],
    defaultSelectedKeys: [],
    mode: "inline",
    openKeys: [],
    items: [],
    selectedKeys: [],
  });
  const menuContext = useRef<any>(null);

  const setMenuContext= useCallback((callback:(value:any)=>any) => {
    setMenusSelectConfig((value)=>{
      const newValue= callback(value);
      changeMenuConfigRef(newValue);
      return newValue
    });
  },[])
  const onSelect: MenuProps["onSelect"] = useCallback((data: any) => {
    console.log('menu select',data);
    setMenuContext((prev) => ({ ...prev, selectedKeys: [data.key] }));
    props.menuSelectHandle && props.menuSelectHandle(data);
  }, []);

  const onOpenChange: MenuProps["onOpenChange"] = useCallback((openKeys: any[]) => {
      const levelKeys = getLevelKeys(menuContext.current.items as LevelKeysProps[]);
    const currentOpenKey = openKeys.find((key) => menuContext.current.openKeys?.indexOf(key) === -1);
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys.filter((key) => key !== currentOpenKey).findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      const keys = openKeys.filter((_, index) => index !== repeatIndex).filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]);
      setMenuContext((prev) => ({ ...prev, openKeys: keys }));
    } else {
      setMenuContext((prev) => ({ ...prev, openKeys }));
    }
  }, []);
  if (menuContext.current == null) {
    menuContext.current = {
      ...menusSelectConfig,
      onSelect,
      onOpenChange,
      ...props.initConfig,
      updateIndex:0,
    };
  }
  const changeMenuConfigRef = useCallback((newConfig:any) => {
    menuContext.current = {
      ...menuContext.current,
      ...newConfig,
      updateIndex: menuContext.current.updateIndex + 1,
    };
  },[])
  
  return [menuContext, setMenuContext];
};

export default useMenusSelect;
